import { billingApi } from '@api/billing/billing.api';

export const {
  useCreateCheckoutSessionMutation,
  useCreateCustomerPortalMutation,
  useLazyLoadPaymentsQuery,
  useSwitchSubscriptionMutation,
  useLoadPlansQuery,
  useLazyLoadSubscriptionQuery,
  useRequestSubscriptionMutation,
} = billingApi;
